import React from 'react';
import {Grid, Typography} from '@mui/material';
import {styled} from "@mui/material/styles";

const BookedSpaceInfoPanelRowFont = styled(Typography)(() => ({
  fontFamily: 'Inter',
  fontStyle: 'normal',
  fontSize: '0.93em',
  lineHeight: '169%',
  letterSpacing: '0.03em',
  textTransform: 'uppercase',
}));

const BookedSpaceInfoPanelFontWeight400 = styled(BookedSpaceInfoPanelRowFont)(() => ({
  fontWeight: 400,
}));

const BookedSpaceInfoPanelFontWeight500 = styled(BookedSpaceInfoPanelRowFont)(() => ({
  fontWeight: 500,
}));

interface BookSpaceInfoPanelRowData {
  label: string;
  value: string | number;
}

interface BookSpaceInfoPanelContentProps {
  data: BookSpaceInfoPanelRowData[];
}

const BookSpaceInfoPanelContent = ({ data }: BookSpaceInfoPanelContentProps) => {
  return (
    <>
      {
        data.map(({ label, value }, index) => {
          return (
            <Grid key={index} item container justifyContent='space-between'>
              <BookedSpaceInfoPanelFontWeight400>{label}:</BookedSpaceInfoPanelFontWeight400>
              <BookedSpaceInfoPanelFontWeight500>{value}</BookedSpaceInfoPanelFontWeight500>
            </Grid>
          )
        })
      }
    </>
  );
};

export default BookSpaceInfoPanelContent;
